import * as React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { useCommon } from 'src/domains/common/Common';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';

export const LogoutButton = observer('LogoutButton', () => {
    const common = useCommon();
    const { loginState } = AppPlayersState.get(common);
    return (
        <Button
            onClick={loginState.logOut}
            size='xs'
            dataTest='button-logout'
        >
            <I18n
                langKey='account.help-box.logout.label'
                defaultText='Log Out'
            />
        </Button>
    );
});
